export default __webpack_public_path__ + "static/add_worklog_manually_v2-58be7440b5557e4ae607994c8042633b.gif";